import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './NewFeatureGroup.rt';
import * as nfgActions from './NewFeatureGroupActions';
import * as actions from '../../../actions'
import _ from 'lodash';
import * as editorNames from '../../../constants/editorNames';
import {AccessRights} from "../../../schemas/accessRightsModel";
import {errorBox_Show} from "../../../actions/A_Popups";
import {addNewFeatureGroup} from "../ProjectScopeActions";
import {toggleFeatureGroupImagePopup} from "../../NewScope/newScopeActions";

const STEPS = {
  VIEW: 0,
  FORM: 1
};

export const ProjectScopeIcons = [
  'accesories.svg','arch.svg','anti_slip.svg','backsplash.svg','backsplash-new.svg','bathtub.svg','bathtub-new.svg',
  'bathtub-fixture.svg','bathtub-liner.svg','beadboard.svg','bottom-cabinet.svg','brackets.svg','bump-out.svg',
  'cabinets.svg','caulk.svg','ceiling.svg','center-island-countertop.svg','chair.svg','countertop.svg',
  'countertop-removal.svg','corner_caddie.svg','crown-molding.svg','curtain_rod.svg','cutouts.svg','dishwasher.svg',
  'dishwasher-strip.svg','edge-profile.svg','fabrication.svg','faucets.svg','fasteners.svg','faucets-new.svg',
  'finishes.svg','flooring.svg','hood.svg','hourly-labor.svg','inside-corner.svg','installation.svg','jetted-tub.svg',
  'large_corner_seat.svg','literature.svg','large_corner_caddie.svg','material.svg','microwave.svg','milling-down.svg',
  'mirror.svg','mirror-new.svg','mosaics.svg','overflow.svg','outlet-cutout.svg','oversized-handling-fee.svg',
  'pattern.svg','plumbing.svg','pony-wall.svg','pony-wall-cap.svg','pony-wall-glass.svg','radius.svg',
  'range-top-cutout.svg','range.svg','refrigerator.svg','replacement-tub.svg','robe_hooks.svg','room.svg',
  'sales_kit.svg','sealer.svg','sinks.svg','signage.svg','shower_bench.svg','shower.svg','showerbase.svg',
  'shower-door.svg','shower-door-handle.svg','shower-fixture.svg','shower-pan.svg','shower-tub.svg',
  'shower-tub-combo.svg','shower-wall.svg','shower-wall-accent.svg','slabs.svg','soap_dish.svg',
  'solid_surface_base.svg','storage.svg','stove-type.svg','tiles.svg','template.svg','topmount-sink-cutout.svg',
  'toilet-new.svg','toilet.svg','toilet_paper_holder.svg','top-cabinet.svg','towel_bar.svg','towel_ring.svg',
  'trip-charge.svg','vanity-cabinet.svg','vanity-handle.svg','valves.svg','walk-in-tub.svg','walls.svg','walls-new.svg',
  'window.svg','window-covering.svg','wood.svg','wood-new.svg','wood-new-2.svg', 'custom-icon-desktop.svg',
  'cabinet_leg.svg', 'garage-hook.svg', 'overhead_rack.svg', 'slat_wall.svg'
]; // removed 'undermount-sink-cutout.svg' cause it has the same icon

function mapStateToProps(state) {
  return {
    AR: AccessRights.get(state),
    newFeatureGroupImage: state.newScope.newFeatureGroupImage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onUpdateTransientField: (groupName, key, value) => {
      dispatch(actions.updateTransientFieldForCustomEditor(editorNames.PENDING_FEATURE_GROUP, {name: groupName}, key, value));
    },
    addPendingFeatureGroup: (name, image, desc) => dispatch(nfgActions.addNewFeatureGroup(name, desc, image)),
    addNewFeatureGroup: (newFeatureGroup) => dispatch(addNewFeatureGroup(newFeatureGroup)),
    errorBox_Show: (props) => dispatch(errorBox_Show(props)),
    toggleFeatureGroupImagePopup: (activeImageEditFeatureGroup) => dispatch(toggleFeatureGroupImagePopup(activeImageEditFeatureGroup))
  };
}

class _NewFeatureGroup extends PureComponent {

  componentWillReceiveProps(nextProps) {
    if (nextProps.newFeatureGroupImage && (this.state.image !== nextProps.newFeatureGroupImage)) {
      this.updateValue('image', nextProps.newFeatureGroupImage);
    }
  }

  static propTypes = {
    newScope: PropTypes.bool
  };

  static defaultProps = {
    newScope: false
  };

  state = {
    groupName: "",
    groupDescription: "",
    image: null,
    step: STEPS.VIEW,
    selectingIcon: false,
    alerts: []
  };

  editImageClick = () => {
    if (this.props.newScope) {
      // console.log("this.props.featureGroup", this.props.featureGroup);
      this.props.toggleFeatureGroupImagePopup({
        image: this.state.image,
        newFeatureGroup: true
      })
    } else {
      this.setState({selectingIcon: true})
    }
  };

  updateValue = (key, value) => {
    let alerts = this.state.alerts;
    if(_.trim(value).length > 0) {
      var al = alerts.indexOf(key);
      if(al >= 0) {
        alerts.splice(al, 1);
      }
    }
    this.setState({alerts, [key]: value});
  };

  setStep = (step) => {
    this.setState({step});
  };

  getIconOptions = () => {
    return ProjectScopeIcons;
  };

  getSelectedIconStyle = () => {
    if(this.state.image) {
      return {
        backgroundImage: "url('/content/views/dashboard/images/icons/pj-scope-icons/enabled/" + this.state.image + "')",
        backgroundSize: "contain"
      };
    }
    return {};
  };

  onSave = () => {
    let alerts = [];
    if(_.trim(this.state.groupName).length === 0 || this.state.groupName.includes('-')) {
      alerts.push("groupName");
    }
    if(_.trim(this.state.image).length === 0) {
      alerts.push("image");
    }
    if(_.trim(this.state.groupDescription).length === 0) {
      alerts.push("groupDescription");
    }

    if(alerts.length === 0) {
/*      if (this.props.newScope) {
        this.props.addNewFeatureGroup({
          name: this.state.groupName,
          image: this.state.image,
          description: this.state.groupDescription
        })
      } else {*/
//        this.props.onUpdateTransientField(this.state.groupName, "name", this.state.groupName);
//        this.props.onUpdateTransientField(this.state.groupName, "image", this.state.image);
//        this.props.onUpdateTransientField(this.state.groupName, "description", this.state.groupDescription);
        this.props.addPendingFeatureGroup(this.state.groupName, this.state.image, this.state.groupDescription);
//      }
      this.onCancel();
    } else {
      if(this.state.groupName.includes('-')) {
        this.props.errorBox_Show({text: 'Feature Group Name cannot contain a hyphen (-).'});
      }
      this.setState({alerts});
    }
  };

  onCancel = () => {
    this.setState({
      groupName: "",
      groupDescription: "",
      image: null,
      step: STEPS.VIEW,
      selectingIcon: false,
      alerts: []
    });
  };

  render = template
}

const NewFeatureGroup = connect(mapStateToProps, mapDispatchToProps)(_NewFeatureGroup);

export default NewFeatureGroup;
export { NewFeatureGroup };
